export function useFormatDate(initialValue: number = 0) {
  const formatDate = (timestamp: any) => {
    if (timestamp) {
      const date = new Date(Number(timestamp));
      const year = date.getFullYear();
      // 月份从0开始，所以需要+1，同时需要保证月份为两位数
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}年${month}月${day}日`;
    }
  };
  const formaTime = (timestamp: any) => {
    if (timestamp) {
      const date = new Date(Number(timestamp));
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      // const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    }
  };
  const formatDateTime = (timestamp: any) => {
    if (timestamp) {
      const date = new Date(Number(timestamp));
      const year = date.getFullYear();
      // 月份从0开始，所以需要+1，同时需要保证月份为两位数
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    }
  };
  return { formatDate, formaTime, formatDateTime };
}
